import { type CSSProperties } from 'react';

export const BlockLoader = (props: { isVisible?: boolean; size?: 'xsm' | 'sm' | 'md' | 'lg'; style?: CSSProperties }) => {
  if (props.isVisible === false) return null;

  return (
    <div className="loader-overlay" style={props.style}>
      <div className="loader-container">
        <div className={`loader-spinner loader-${props.size}`}>
        </div>
      </div>
    </div>
  );
};